import "core-js/modules/es6.array.sort";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { st52ParamStatistics } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '18px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: 'chart35'
    };
  },
  mounted: function mounted() {
    this.getParamStatistics('52');
  },
  methods: {
    getParamStatistics: function getParamStatistics(st) {
      var _this = this;

      var that = this;
      st52ParamStatistics({
        st: st
      }).then(function (res) {
        if (res.success) {
          _this.$emit('leftInfo', res);

          var arr = [];

          for (var key in res.result.processingCapacityMap) {
            arr.push({
              name: key,
              value: res.result.processingCapacityMap[key]
            });
          }

          that.initBarChart(arr);
        }
      });
    },
    initBarChart: function initBarChart(arr) {
      var option = {
        legend: {
          orient: 'vertical',
          // 'vertical'
          x: 'left',
          // 'center' | 'left' | {number},
          y: '80',
          // 'center' | 'bottom' | {number}
          padding: 10,
          // [5, 10, 15, 20]
          itemGap: 20,
          textStyle: {
            color: '#c3cad9'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        series: [{
          name: '设计处理能力',
          type: 'pie',
          radius: '50%',
          center: ['50%', '50%'],
          color: ['#43cadd', '#3893e5', '#FCC708', '#03B48E'],
          //'#FBFE27','rgb(11,228,96)','#FE5050'
          data: arr.sort(function (a, b) {
            return a.value - b.value;
          }),
          label: {
            normal: {
              // formatter: ['{c|{b}{d}%}', '{b|{b}}'].join('\n'),
              // formatter: ['{b|{b}{d}%}', '{c|{c}万元}'].join('\n'),
              rich: {
                b: {
                  color: '#d9efff',
                  fontSize: 15,
                  height: 40
                },
                c: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 'bold',
                  lineHeight: 5
                }
              }
            }
          },
          itemStyle: {
            borderWidth: '20',
            color: 'pink',
            borderColor: '#FFF',
            normal: {
              borderWidth: '5',
              borderColor: 'rgba(255,255,255,2)'
            }
          },
          labelLine: {
            normal: {
              backgroundColor: 'yellow',
              borderColor: 'skyblue',
              borderWidth: 10,
              lineStyle: {
                borderColor: 'skyblue',
                borderWidth: 10,
                backgroundColor: 'yellow'
              }
            }
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};